import { gql } from '@apollo/client'

export const AUDIT_LOGS_QUERY = gql`
  query AuditLogs($input: AuditLogFiltersInput!) {
    auditLogs(input: $input) {
      totalNumberOfLogs
      requestID
      logs {
        logContent {
          data
          entities {
            entityCode
            displayEntityCode
            entityID
            entityName
            entityType
            subEntities {
              entityCode
              displayEntityCode
              entityID
              entityName
              entityType
              subEntities {
                entityCode
                displayEntityCode
                entityID
                entityName
                entityType
                subEntities {
                  entityCode
                  displayEntityCode
                  entityID
                  entityName
                  entityType
                }
              }
            }
          }
          changedFields {
            field
            oldValue
            newValue
          }
        }
        correlationID
        entities {
          entityCode
          displayEntityCode
          entityID
          entityName
          entityType
          subEntities {
            entityCode
            displayEntityCode
            entityID
            entityName
            entityType
            subEntities {
              entityCode
              displayEntityCode
              entityID
              entityName
              entityType
              subEntities {
                entityCode
                displayEntityCode
                entityID
                entityName
                entityType
              }
            }
          }
        }
        level
        action
        occurredAt
        response
        user {
          email
          entityCode
          entityID
          role
          id
          ip
          userAgent
          connectionMethod
          name
        }
        isValidHash
      }
    }
  }
`

export const AUDIT_LOGS_COUNT_QUERY = gql`
  query AuditLogsCount($input: AuditLogFiltersInput!) {
    auditLogsCount(input: $input) {
      totalNumberOfLogs
    }
  }
`

export const AUDIT_LOGS_ACTION_NAMES_QUERY = gql`
  query ActionNames {
    actionNames {
      label
      value
    }
  }
`
